import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@store/types';
import { AppointmentTypesUIState } from './slice';

const emptyState: AppointmentTypesUIState = {
  expandableFields: {},
  selectedTypeId: null,
  isAddModalOpen: false,
};

// Base selector
export const selectAppointmentTypesUIState = (state: RootState) =>
  state.appointmentTypes || emptyState;

// Field expansion selectors
export const selectExpandableFields = createSelector(
  [selectAppointmentTypesUIState],
  state => state.expandableFields,
);

export const makeSelectFieldExpanded = (fieldId: string) =>
  createSelector([selectExpandableFields], fields => fields[fieldId] ?? false);

// Other selectors
export const selectSelectedTypeId = createSelector(
  [selectAppointmentTypesUIState],
  state => state.selectedTypeId,
);

export const selectIsAddModalOpen = createSelector(
  [selectAppointmentTypesUIState],
  state => state.isAddModalOpen,
);
